<template>
    <div>
        <a
            class="quick-view-button block p-sm"
            @click="showQuickView"
        >
            <font-awesome-icon icon="info" />
        </a>

        <adaptive-modal
            :name="modalName"
            :show-hide-button="false"
            height="85%"
            primary-button-text="Färdig"
            primary-button-class="is-ghost"
            title="Summering"
            width="95%"
            @save="hideQuickView"
        >
            <div class="relative" style="height: 75%">
                <iframe :src="url" class="h-full w-full" />
            </div>
        </adaptive-modal>
    </div>
</template>
<script>
    export default {
        props: {
            sourceId: {
                type: Number,
                required: true,
            },
            subcontractorId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                modalName: `summary-quick-view-${this.subcontractorId}-${this.sourceId}`,
            };
        },

        computed: {
            url() {
                return `/sales-periods/${this.sourceId}/teams/${this.subcontractorId}/transactions-summary`;
            },
        },

        methods: {
            hideQuickView() {
                this.$modal.hide(this.modalName);
            },
            showQuickView() {
                this.$modal.show(this.modalName);
            },
        },
    };
</script>
